<div #root class="sb-seg"
     [class.sb-seg--dense]="dense()"
     [class.sb-seg--stretch]="stretch()"
     role="radiogroup" [attr.aria-label]="ariaLabel()">
  @for (option of options(); track option.value; let i = $index) {
    <button type="button"
            class="sb-seg__item"
            [class.is-on]="option.value === value()"
            [attr.data-value]="option.value"
            role="radio"
            [attr.aria-checked]="option.value === value()"
            [disabled]="option.disabled"
            [attr.aria-disabled]="option.disabled ? 'true' : null"
            [attr.aria-describedby]="option.disabled && disabledReason() ? reasonId : null"
            [attr.tabindex]="option.value === tabbableValue() ? 0 : -1"
            (click)="select(option)"
            (keydown)="onKeydown($event, i)">
      {{ option.label }}
    </button>
  }
</div>
@if (disabledReason(); as reason) {
  <span class="sb-seg__reason" [id]="reasonId">{{ reason }}</span>
}
